import { useEffect } from 'react';

import { useSearchActions } from '../../controllers/store/search';
import { useQueryFilters } from './textfield/query-filters';

type ExternalInputQuerySyncProps = {
	localQuery: string;
	postQueryDisabled?: boolean;
};

/**
 * Keeps the Quick Find store in step with a host-owned input. `SearchTextField` normally does this
 * as a side effect of rendering; in external-input mode it is not rendered, so the same hooks run
 * here instead.
 */
export const ExternalInputQuerySync = ({
	localQuery,
	postQueryDisabled,
}: ExternalInputQuerySyncProps): null => {
	const { setQueryUpdatedTime } = useSearchActions();

	useQueryFilters(localQuery, postQueryDisabled);

	useEffect(() => {
		setQueryUpdatedTime();
	}, [setQueryUpdatedTime, localQuery]);

	return null;
};
